import { render, staticRenderFns } from "./SimCard.vue?vue&type=template&id=1c9afa34&scoped=true&"
import script from "./SimCard.vue?vue&type=script&lang=js&"
export * from "./SimCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9afa34",
  null
  
)

export default component.exports